module.exports = __webpack_public_path__ + "static/media/servicio_inversion_mobiliaria.f18df75c.jpg";